module.exports = __webpack_public_path__ + "static/media/header-375.091857b9.jpg";